<template>
  <div class="m-0 d-flex flex-column gap-3">
    <!-- Informacion Personal -->
    <form ref="formRef" novalidate @submit.prevent="savePersonalInfo" class="d-flex align-items-center gap-4 fondo-terciario rounded-4 p-3 px-4 sombra-sm mb-4">
      <div class="card-body">
        <div class="d-flex flex-column flex-md-row align-items-center gap-4">
          <div class="w-100">
            <div class="d-flex justify-content-between align-items-center mb-3 w-100">
              <h2 class="fw-bold fs-5 m-0 mt-1">{{ $t('infoPersonal') }}</h2>
              <button @click="isEditingPersonal = true" v-if="(hasEditarPersonaPermission && !isEditingPersonal) || isEditingPerfil" type="button" class="btn p-0 d-flex flex-row align-items-center justify-content-center tooltip-container border-0">
                <svg width="20" height="20" viewBox="0 0 24 24" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M21 21H12" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span class="tooltip-text">{{ $t('editar') }}</span>
              </button>
            </div>
            <div class="row">
              <div class="col-md-6 mb-3 d-flex flex-column">
                <label class="m-0 texto-secundario fs-7">{{ $t('apellido') }}:</label>
                <p v-if="!isEditingPersonal || isEditingPerfil" class="m-0">{{ persona.Apellido }}</p>
                <input v-if="isEditingPersonal && !isEditingPerfil" type="text" v-model="localPersona.Apellido" class="form-control fondo-principal sombra-sm" :disabled="!isEditingPersonal" maxlength="100" />
              </div>
              <div class="col-md-6 mb-3 d-flex flex-column" v-if="persona.ApellidoCasada">
                <label class="m-0 texto-secundario fs-7">{{ $t('apellidoCasada') }}:</label>
                <p v-if="!isEditingPersonal || isEditingPerfil" class="m-0">{{ persona.ApellidoCasada }}</p>
                <input v-if="isEditingPersonal && !isEditingPerfil" type="text" v-model="localPersona.ApellidoCasada" class="form-control fondo-principal sombra-sm" :disabled="!isEditingPersonal" maxlength="100"/>
              </div>
              <div class="col-md-6 mb-3 d-flex flex-column">
                <label class="m-0 texto-secundario fs-7">{{ $t('nombre') }}:</label>
                <p v-if="!isEditingPersonal || isEditingPerfil" class="m-0">{{ persona.Nombre }}</p>
                <input v-if="isEditingPersonal && !isEditingPerfil" type="text" v-model="localPersona.Nombre" class="form-control fondo-principal sombra-sm" :disabled="!isEditingPersonal" maxlength="100" />
              </div>
              <div class="col-md-6 mb-3 d-flex flex-column" v-if="persona.NombreInformal">
                <label class="m-0 texto-secundario fs-7">{{ $t('nombreInformal') }}:</label>
                <p v-if="!isEditingPersonal" class="m-0">{{ persona.NombreInformal }}</p>
                <input v-if="isEditingPersonal" type="text" v-model="localPersona.NombreInformal" class="form-control fondo-principal sombra-sm" :disabled="!isEditingPersonal" maxlength="100"/>
              </div>
              <div class="col-md-6 mb-3 d-flex flex-column">
                <label class="m-0 texto-secundario fs-7">{{ $t('dni') }}:</label>
                <p v-if="!isEditingPersonal || isEditingPerfil" class="m-0">{{ formatDni(persona.Dni) }}</p>
                <input v-if="isEditingPersonal && !isEditingPerfil" type="text" v-model="dniInput" @input="handleDniInput" class="form-control fondo-principal sombra-sm" :disabled="!isEditingPersonal" />
              </div>
              <div class="col-md-6 mb-3 d-flex flex-column">
                <label class="m-0 texto-secundario fs-7">{{ $t('pasaporte') }}:</label>
                <p v-if="!isEditingPersonal || isEditingPerfil" class="m-0">{{ persona.Pasaporte || 'N/A' }}</p>
                <input v-if="isEditingPersonal && !isEditingPerfil" type="text" v-model="localPersona.Pasaporte" class="form-control fondo-principal sombra-sm" :disabled="!isEditingPersonal" />
              </div>
              <div class="col-md-6 mb-3 d-flex flex-column">
                <label class="m-0 texto-secundario fs-7">{{ $t('fechaNacimiento') }}{{ isEditingPersonal && isEditingPerfil ? '*' : '' }}:</label>
                <p v-if="!isEditingPersonal" class="m-0">{{ formattedFechaNac || 'N/A' }}</p>
                <input v-if="isEditingPersonal" type="date" v-model="localPersona.FechaNac" class="form-control fondo-principal sombra-sm" :disabled="!isEditingPersonal" required />
                <div class="invalid-feedback">{{ $t('fechaNacimientoRequerida') }}</div>
              </div>
              <div class="col-md-6 mb-3 d-flex flex-column">
                <label class="m-0 texto-secundario fs-7">{{ $t('genero') }}{{ isEditingPersonal && isEditingPerfil ? '*' : '' }}:</label>
                <p v-if="!isEditingPersonal" class="m-0">{{ $t(obtenerNombreGenero(persona.Genero)?.toLocaleLowerCase()) }}</p>
                <div v-if="isEditingPersonal" class="select-wrapper">
                  <select id="genero" v-model="localPersona.Genero" class="form-select fondo-principal sombra-sm" :disabled="!isEditingPersonal" required>
                    <option value="M">{{ $t('masculino') }}</option>
                    <option value="F">{{ $t('femenino') }}</option>
                    <option value="X">{{ $t('noBinario') }}</option>
                    <option value="-">{{ $t('prefieroNoDecirlo') }}</option>
                  </select>
                  <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
                  </svg>
                  <div class="invalid-feedback">{{ $t('generoRequerido') }}</div>
                </div>
              </div>
              <div class="col-md-6 d-flex flex-column" :class="{'mb-3' : !isEditingPerfil }">
                <label class="m-0 texto-secundario fs-7">{{ $t('estadoCivil') }}{{ isEditingPersonal && isEditingPerfil ? '*' : '' }}:</label>
                <p v-if="!isEditingPersonal" class="m-0">{{ estadoCivilDisplay }}</p>
                <div v-if="isEditingPersonal" class="select-wrapper">
                  <select id="estadoCivil" v-model="localPersona.IdEstadoCivil" class="form-select fondo-principal sombra-sm" :disabled="!isEditingPersonal" required>
                    <option v-for="estado in estadoCivil" :key="estado.IdEstadoCivil" :value="estado.IdEstadoCivil">
                      {{ $t(`${ estado.estadoCivil.replace(/\s+/g, '')}`) }}
                    </option>
                  </select>
                  <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
                  </svg>
                  <div class="invalid-feedback">{{ $t('estadoCivilRequerido') }}</div>
                </div>
              </div>
              <div v-if="!isEditingPerfil" class="col-md-6 mb-3 d-flex flex-column">
                <label class="m-0 texto-secundario fs-7">{{ $t('fechaFallecimiento') }}:</label>
                <p v-if="!isEditingPersonal" class="m-0">{{ persona.FechaFallecimiento || 'N/A' }}</p>
                <input v-if="isEditingPersonal" type="date" v-model="localPersona.FechaFallecimiento" class="form-control fondo-principal sombra-sm" :disabled="!isEditingPersonal" />
              </div>
              <div v-if="!isEditingPerfil" class="col-12 d-flex flex-column">
                <label class="m-0 texto-secundario fs-7">{{ $t('observaciones') }}:</label>
                <p v-if="!isEditingPersonal" class="m-0">{{ persona.Observaciones || 'N/A' }}</p>
                <textarea v-if="isEditingPersonal" v-model="localPersona.Observaciones" class="form-control fondo-principal sombra-sm" rows="4" maxlength="2000" :disabled="!isEditingPersonal"></textarea>
              </div>
            </div>
            <div v-if="isEditingPersonal" class="d-flex justify-content-end gap-2 mt-3">
              <button class="btn success-btn sombra-sm d-flex align-items-center gap-2" type="submit" :disabled="loadingPersonalInfo">
                {{ $t('guardarCambios') }}
                <img v-if="loadingPersonalInfo" src="@/assets/LOADING.gif" style="width: 20px;" alt="Cargando..." />
              </button>
              <button class="btn secondary-btn sombra-sm" type="button" @click="cancelEdit">{{ $t('cancelar') }}</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { ref, computed, watch, onMounted, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import api from '@/services/api';

export default {
  name: 'DatosPersonalesTab',
  props: {
    persona: {
      type: Object,
      default: () => ({})
    },
    hasEditarPersonaPermission: {
      type: Boolean,
      default: false
    },
    isEditingPerfil: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const isEditingPersonal = ref(false);
    const loadingPersonalInfo = ref(false);
    const estadoCivil = ref(false);
    const localPersona = ref({ ...props.persona });
    const errors = ref({});
    const formRef = ref(null);

    const obtenerNombreGenero = (codigo) => {
      switch (codigo) {
        case 'M':
          return 'Masculino';
        case 'F':
          return 'Femenino';
        case 'X':
          return 'No Binario';
        case '-':
          return 'Prefiero No Decirlo';
        default:
          return 'Desconocido';
      }
    };

    const cleanDni = (value) => {
      const onlyNumbers = String(value || '').replace(/\D/g, '');
      return onlyNumbers.slice(0, 8);
    };

    const formatDni = (value) => {
      const dniSinPuntos = cleanDni(value);
      return dniSinPuntos.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    };

    const handleDniInput = (event) => {
      const rawValue = event.target.value;
      const cleanValue = cleanDni(rawValue);
      localPersona.value.Dni = cleanValue;
      event.target.value = formatDni(cleanValue);
    };

    const dniInput = computed(() => {
      return formatDni(localPersona.value.Dni);
    });

    const formattedFechaNac = computed(() => {
      if (!props.persona.FechaNac) return '';
      const [year, month, day] = props.persona.FechaNac.split('-');
      const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
      const formattedDay = String(date.getDate()).padStart(2, '0');
      const formattedMonth = String(date.getMonth() + 1).padStart(2, '0');
      const formattedYear = date.getFullYear();
      return `${formattedDay}/${formattedMonth}/${formattedYear}`;
    });

    const estadoCivilDisplay = computed(() => {
      const found = estadoCivil.value?.find ? estadoCivil.value.find(ec => ec.IdEstadoCivil == props.persona.IdEstadoCivil) : null;
      return found ? t(`${found.estadoCivil}`) : 'N/A';
    });

    const validatePersonalInfo = async () => {
      errors.value = {};
      let isValid = true;
      if(props.isEditingPerfil){
        if (!localPersona.value.FechaNac) {
          errors.value.FechaNac = t('fechaNacimientoRequerida');
          isValid = false;
        }
        if (!localPersona.value.IdEstadoCivil) {
          errors.value.IdEstadoCivil = t('estadoCivilRequerido');
          isValid = false;
        }
        if (!localPersona.value.Genero) {
          errors.value.Genero = t('generoRequerido');
          isValid = false;
        }
      }
      if(localPersona.value.FechaNac == ""){
        localPersona.value.FechaNac = null
      }
      await nextTick();
      if (!isValid) {
        formRef.value?.classList.add('was-validated');
      } else {
        formRef.value?.classList.remove('was-validated');
      }
      return isValid;
    };

    const savePersonalInfo = async () => {
      if (!(await validatePersonalInfo())) {
        return;
      }
      loadingPersonalInfo.value = true;
      console.log(localPersona.value.FechaNac)
      try {
        const data = {
          apellido: localPersona.value.Apellido,
          nombre: localPersona.value.Nombre,
          Dni: localPersona.value.Dni === "" ? null : localPersona.value.Dni,
          pasaporte: localPersona.value.Pasaporte,
          genero: localPersona.value.Genero,
          fechaNac: localPersona.value.FechaNac,
          idEstadoCivil: localPersona.value.IdEstadoCivil,
          fechaFallecimiento: localPersona.value.FechaFallecimiento || null,
          observaciones: localPersona.value.Observaciones
        };
        await api.put(`api/Persona/${props.persona.IdPersona}/info-personal`, data);
        isEditingPersonal.value = false;
        emit('updated');
      } catch (error) {
        console.error('Error al guardar info personal:', error);
        alert('Hubo un problema al guardar la información personal.');
      } finally {
        loadingPersonalInfo.value = false;
      }
    };

    const cancelEdit = () => {
      localPersona.value = { ...props.persona };
      isEditingPersonal.value = false;
    };

    const fetchEstadoCivil = async () => {
      try {
        const response = await api.get(`api/ExtrasPersonas/EstadosCiviles`);
        estadoCivil.value = response.data; // Asumiendo que la respuesta contiene un array de usuarios
        //console.log(estadoCivil.value)
      } catch (error) {
        console.error('Error al obtener datos del usuario:', error);
      }
    };

    watch(() => props.persona, (newPersona) => {
      localPersona.value = { ...newPersona };
    }, { immediate: true });

    onMounted(async () => {
      await fetchEstadoCivil();
    });

    return {
      t,
      isEditingPersonal,
      loadingPersonalInfo,
      localPersona,
      obtenerNombreGenero,
      cleanDni,
      formatDni,
      handleDniInput,
      dniInput,
      savePersonalInfo,
      cancelEdit,
      estadoCivil,
      formattedFechaNac,
      estadoCivilDisplay,
      validatePersonalInfo,
      errors,
      formRef,
    };
  },
};
</script>

<style>
</style>